import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "alert alert-info py-2 small mb-2"
}
const _hoisted_2 = { class: "card mb-2" }
const _hoisted_3 = { class: "card-body py-2" }
const _hoisted_4 = { class: "form-row" }
const _hoisted_5 = { class: "col-lg-3 my-input-1" }
const _hoisted_6 = { class: "col-lg-2 date-input" }
const _hoisted_7 = { class: "col-lg-3" }
const _hoisted_8 = { class: "form-row" }
const _hoisted_9 = { class: "col-lg-6" }
const _hoisted_10 = { class: "col-lg-6" }
const _hoisted_11 = { class: "form-row" }
const _hoisted_12 = { class: "col-lg-6" }
const _hoisted_13 = { class: "col-lg-6" }
const _hoisted_14 = { class: "form-row" }
const _hoisted_15 = { class: "col-lg-12" }
const _hoisted_16 = { class: "form-row" }
const _hoisted_17 = { class: "col-lg-3 date-input" }
const _hoisted_18 = { class: "col-lg-3" }
const _hoisted_19 = { class: "card mb-2" }
const _hoisted_20 = { class: "card-body py-2" }
const _hoisted_21 = { class: "form-row" }
const _hoisted_22 = { class: "col-lg-6" }
const _hoisted_23 = { class: "col-lg-6" }
const _hoisted_24 = { class: "form-row" }
const _hoisted_25 = { class: "col-lg-6" }
const _hoisted_26 = { class: "col-lg-6" }
const _hoisted_27 = { class: "form-row" }
const _hoisted_28 = { class: "col-lg-6" }
const _hoisted_29 = { class: "col-lg-6" }
const _hoisted_30 = { class: "card mb-2" }
const _hoisted_31 = { class: "card-body py-2" }
const _hoisted_32 = { class: "card mb-2" }
const _hoisted_33 = { class: "card-body py-2 small" }
const _hoisted_34 = { class: "mb-1" }
const _hoisted_35 = { key: 0 }
const _hoisted_36 = { class: "mb-1" }
const _hoisted_37 = { class: "form-row" }
const _hoisted_38 = { class: "col-lg-12" }
const _hoisted_39 = { class: "mb-1 text-muted" }
const _hoisted_40 = { class: "mb-0 text-muted" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DBEdit = _resolveComponent("DBEdit")!
  const _component_DBGrid = _resolveComponent("DBGrid")!
  const _component_Card = _resolveComponent("Card")!
  const _component_DBForm = _resolveComponent("DBForm")!

  return (_openBlock(), _createBlock(_component_DBForm, {
    store: _ctx.store,
    config: _ctx.settings,
    data: _ctx.data,
    ref: "form"
  }, {
    default: _withCtx((form) => [
      _createVNode(_component_Card, {
        panelFun: _ctx.controller.panelFun.value,
        panel: _ctx.panel.key
      }, {
        default: _withCtx(() => [
          (form.data?.status === 'posted')
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, " Документ проведён: движения по складу сформированы. Позиции табличной части недоступны для изменения. Для исправления переведите статус в «Черновик», сохраните, затем снова проведите. "))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_2, [
            _cache[0] || (_cache[0] = _createElementVNode("div", { class: "card-header bg-light py-1" }, [
              _createElementVNode("h6", { class: "mb-0" }, "Акт списания медикаментов и перевязочных средств")
            ], -1)),
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createVNode(_component_DBEdit, {
                    form: form,
                    field: "act_number",
                    clear: ""
                  }, null, 8, ["form"])
                ]),
                _createElementVNode("div", _hoisted_6, [
                  _createVNode(_component_DBEdit, {
                    form: form,
                    field: "act_date",
                    clear: ""
                  }, null, 8, ["form"])
                ]),
                _createElementVNode("div", _hoisted_7, [
                  _createVNode(_component_DBEdit, {
                    form: form,
                    field: "status",
                    clear: ""
                  }, null, 8, ["form"])
                ])
              ]),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _createVNode(_component_DBEdit, {
                    form: form,
                    field: "warehouse_id"
                  }, null, 8, ["form"])
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _createVNode(_component_DBEdit, {
                    form: form,
                    field: "department_id"
                  }, null, 8, ["form"])
                ])
              ]),
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                  _createVNode(_component_DBEdit, {
                    form: form,
                    field: "responsible_position",
                    clear: ""
                  }, null, 8, ["form"])
                ]),
                _createElementVNode("div", _hoisted_13, [
                  _createVNode(_component_DBEdit, {
                    form: form,
                    field: "responsible_fio",
                    clear: ""
                  }, null, 8, ["form"])
                ])
              ]),
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("div", _hoisted_15, [
                  _createVNode(_component_DBEdit, {
                    form: form,
                    field: "commission_text",
                    clear: ""
                  }, null, 8, ["form"])
                ])
              ]),
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("div", _hoisted_17, [
                  _createVNode(_component_DBEdit, {
                    form: form,
                    field: "order_date",
                    clear: ""
                  }, null, 8, ["form"])
                ]),
                _createElementVNode("div", _hoisted_18, [
                  _createVNode(_component_DBEdit, {
                    form: form,
                    field: "order_number",
                    clear: ""
                  }, null, 8, ["form"])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_19, [
            _cache[1] || (_cache[1] = _createElementVNode("div", { class: "card-header bg-light py-1" }, [
              _createElementVNode("h6", { class: "mb-0" }, "Комиссия: подписи (должность, ФИО)")
            ], -1)),
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("div", _hoisted_22, [
                  _createVNode(_component_DBEdit, {
                    form: form,
                    field: "chair_position",
                    clear: ""
                  }, null, 8, ["form"])
                ]),
                _createElementVNode("div", _hoisted_23, [
                  _createVNode(_component_DBEdit, {
                    form: form,
                    field: "chair_fio",
                    clear: ""
                  }, null, 8, ["form"])
                ])
              ]),
              _createElementVNode("div", _hoisted_24, [
                _createElementVNode("div", _hoisted_25, [
                  _createVNode(_component_DBEdit, {
                    form: form,
                    field: "member1_position",
                    clear: ""
                  }, null, 8, ["form"])
                ]),
                _createElementVNode("div", _hoisted_26, [
                  _createVNode(_component_DBEdit, {
                    form: form,
                    field: "member1_fio",
                    clear: ""
                  }, null, 8, ["form"])
                ])
              ]),
              _createElementVNode("div", _hoisted_27, [
                _createElementVNode("div", _hoisted_28, [
                  _createVNode(_component_DBEdit, {
                    form: form,
                    field: "member2_position",
                    clear: ""
                  }, null, 8, ["form"])
                ]),
                _createElementVNode("div", _hoisted_29, [
                  _createVNode(_component_DBEdit, {
                    form: form,
                    field: "member2_fio",
                    clear: ""
                  }, null, 8, ["form"])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_30, [
            _cache[2] || (_cache[2] = _createElementVNode("div", { class: "card-header bg-light py-1" }, [
              _createElementVNode("h6", { class: "mb-0" }, "Списываемые медикаменты и перевязочные средства")
            ], -1)),
            _createElementVNode("div", _hoisted_31, [
              _createVNode(_component_DBGrid, {
                form: form,
                field: "items",
                config: _ctx.settings.fields.items,
                owner: form.data?.id,
                readonly: form.data?.status === 'posted',
                ref: "itemsGrid"
              }, null, 8, ["form", "config", "owner", "readonly"])
            ])
          ]),
          _createElementVNode("div", _hoisted_32, [
            _cache[6] || (_cache[6] = _createElementVNode("div", { class: "card-header bg-light py-1" }, [
              _createElementVNode("h6", { class: "mb-0" }, "Итоги и основания")
            ], -1)),
            _createElementVNode("div", _hoisted_33, [
              _createElementVNode("p", _hoisted_34, [
                _cache[3] || (_cache[3] = _createElementVNode("strong", null, "Всего по акту списания, количество:", -1)),
                _createTextVNode(" " + _toDisplayString(_ctx.totalQty) + " (сумма натуральных единиц по строкам: кол-во уп. × кол-во в уп. по М-17). ", 1),
                (_ctx.qtyWords)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_35, [
                      _createElementVNode("em", null, _toDisplayString(_ctx.qtyWords), 1)
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("p", _hoisted_36, [
                _cache[4] || (_cache[4] = _createElementVNode("strong", null, "Всего по акту списания, сумма:", -1)),
                _createTextVNode(" " + _toDisplayString(_ctx.totalAmt.toFixed(2)) + " руб. ", 1)
              ]),
              _createElementVNode("div", _hoisted_37, [
                _createElementVNode("div", _hoisted_38, [
                  _createVNode(_component_DBEdit, {
                    form: form,
                    field: "funding_sources_note"
                  }, null, 8, ["form"])
                ])
              ]),
              _cache[5] || (_cache[5] = _createElementVNode("hr", null, null, -1)),
              _createElementVNode("p", _hoisted_39, " Материально-ответственное лицо: " + _toDisplayString(_ctx.footerMol), 1),
              _createElementVNode("p", _hoisted_40, "Комиссия: " + _toDisplayString(_ctx.footerCommission), 1)
            ])
          ])
        ]),
        _: 2
      }, 1032, ["panelFun", "panel"])
    ]),
    _: 1
  }, 8, ["store", "config", "data"]))
}